<script>
  import { onMount, onDestroy } from "svelte";

  export let options = [];
  export let selectedOption;
  export let onOptionSelect = () => {};

  let isOpen = false;
  let dropdownRef;

  function toggleDropdown() {
    isOpen = !isOpen;
  }

  function selectOption(option) {
    selectedOption = option;
    onOptionSelect(option);
    isOpen = false; // Close the dropdown after selection
  }

  function handleClickOutside(event) {
    // Check if the clicked target is outside the dropdown
    if (dropdownRef && !dropdownRef.contains(event.target)) {
      isOpen = false; // Close the dropdown
    }
  }

  function handleKeydown(event) {
    // Toggle dropdown on Enter or Space key
    if (event.key === "Enter" || event.key === " ") {
      toggleDropdown();
      event.preventDefault(); // Prevent default behavior for space
    }
  }

  // Set up event listener for clicks outside
  onMount(() => {
    document.addEventListener("click", handleClickOutside);
  });

  // Clean up the event listener when the component is destroyed
  onDestroy(() => {
    document.removeEventListener("click", handleClickOutside);
  });
</script>

<div class="dropdown" bind:this={dropdownRef}>
  <!-- Use a button for toggling the dropdown -->
  <button 
    class="dropdown-button" 
    on:click={toggleDropdown} 
    on:keydown={event => {
      if (event.key === 'Enter' || event.key === ' ') {
        toggleDropdown();
        event.preventDefault(); // Prevent default behavior for space
      }
    }}
    aria-haspopup="true"
    aria-expanded={isOpen}>
    <div class="dropdown-button__text">
    {selectedOption || 'Select a year'}
    </div><svg
      class="svg-icon {isOpen ? "isOpen":""}"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 83.67 83.67"
    >
      <polyline
        fill="none"
        stroke="currentColor"
        stroke-miterlimit="10"
        stroke-width="8"
        points="35.18 24.29 52.8 41.91 35.18 59.52"
      />
      <rect fill="none" width="83.67" height="83.67" />
    </svg>
  </button>
  
  {#if isOpen}
    <ul class="dropdown-list">
      {#each options as option}
        <li 
          class:selected={option === selectedOption} 
          on:click={() => selectOption(option)}>
          {option}
        </li>
      {/each}
    </ul>
  {/if}
</div>

<style>
  .dropdown {
    position: relative;
    display: inline-block;
    width: 86px;
  }

  .dropdown-button {
    padding: 8px;
    font-size: 1rem;
    width: 100%;
    min-height: 44px;
    cursor: pointer;
    font-weight: bold;
    display: flex;
    align-items: center;
    background: white;
    border: 1px solid #ccc;
    
    color: #333;
  }

  .dropdown-button__text {
    margin-right: 8px
  }

  .dropdown-list {
    position: absolute;
    background: white;
    border: 1px solid #ccc;
    list-style-type: none;
    padding: 0;
    margin: 0;
    width: 100%;
    z-index: 1;
    max-height: 300px;
    overflow-y: auto;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  .dropdown-list li {
    padding: 12px;
    cursor: pointer;
  }

  .dropdown-list li.selected {
    font-weight: bold; /* Make selected option bold */
    background: #aa5526;
    font-weight: bold;
    color: #fff;
  }

  .dropdown-list li:hover {
    background-color: #f0f0f0; /* Optional: hover effect */
  }
  .svg-icon {
    /* margin-right: 0.5rem; */
    vertical-align: 0px;
    width: 1rem; /* Adjust size as needed */
    height: 1rem; /* Adjust size as needed */
    fill: currentColor; /* This will use the current text color */
    background: #aa5526;
    border-radius: 50%;
    color: #fff;
    transform: rotate(90deg);
    transition: transform 0.2s ease-in-out;
  }
  .svg-icon.isOpen {
    
    transform: rotate(270deg);
  }



  .dropdown-list::-webkit-scrollbar {
    width: 18px;
  }
  .dropdown-list {
    scrollbar-width: thin;
    scrollbar-color: #aa5526 #fff;
  }
  .dropdown-list::-webkit-scrollbar-track {
    background: #fff;
  }
  .dropdown-list::-webkit-scrollbar-thumb {
    background-color: #aa5526 ;
    border-radius: 6px;
    border: 3px solid #fff;
  }

</style>